import { translate } from '@/shared/i18n'

// Template-facing bridge for the legacy `__()` helper. The implementation
// lives in @/shared/i18n so setup()/composable code can share it.
export default {
    methods: {
        __(key, replace) {
            return translate(key, replace)
        },
    },
}
